import { Box, Button, Grid, Link, Typography } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Panelimg from "../../../../Assets/provider.jpeg";
import dayjs from "dayjs";

const UrlDetails = ({ data }) => {
  const images =
    Array.isArray(data.photos) && data.photos.length
      ? data.photos
      : [{ photo_url: Panelimg }];
  const hasMultiple = images.length > 1;
  const settings = {
    dots: hasMultiple,
    infinite: hasMultiple,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
  };
  console.log(images);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        width: { xs: "100%", md: "60%" },
        gap: { xs: "30px", md: 0 },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 800, margin: "0 auto" }}>
        {hasMultiple ? (
          <Slider {...settings}>
            {images.map((img, idx) => (
              <Box
                key={idx}
                sx={{
                  height: 300,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {img.photo_url ? (
                  <Box
                    component="img"
                    src={img.photo_url}
                    alt={`slide-${idx}`}
                    sx={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                      borderRadius: 2,
                    }}
                  />
                ) : (
                  <Typography variant="h4" sx={{ textAlign: "center" }}>
                    No Image
                  </Typography>
                )}
              </Box>
            ))}
          </Slider>
        ) : (
          <Box
            sx={{
              height: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {images[0].photo_url ? (
              <Box
                component="img"
                src={images[0].photo_url}
                alt="single-image"
                sx={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                  borderRadius: 2,
                }}
              />
            ) : (
              <Typography variant="h4" sx={{ textAlign: "center" }}>
                No Image
              </Typography>
            )}
          </Box>
        )}
      </Box>
      <a
        href={data?.smmpanel_url}
        target="_blank"
        className={`flex w-full justify-center`}
      >
        <Button
          sx={{
            backgroundColor: "primary.main",
            color: "white",
            textAlign: "center",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: "bold",
            padding: 3,
            paddingY: 1,
            borderRadius: "0.25rem",
            "&:hover": {
              backgroundColor: "#114797",
            },
          }}
          //   onClick={() => window.open(Panel.url, "_blank")}
        >
          Visit Provider Website
          <svg
            width="20"
            height="20"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: "6px" }}
          >
            <g clip-path="url(#clip0_179_2758)">
              <path
                d="M9.41487 3.61514H6.91015C5.3515 3.61514 4.5716 3.61514 3.97628 3.91848C3.45262 4.18529 3.02718 4.61073 2.76037 5.1344C2.45703 5.72971 2.45703 6.50962 2.45703 8.06826V18.6438C2.45703 20.2024 2.45703 20.9814 2.76037 21.5766C3.02718 22.1003 3.45262 22.5265 3.97628 22.7932C4.57102 23.0963 5.34997 23.0963 6.90557 23.0963H17.4897C19.0452 23.0963 19.8231 23.0963 20.4178 22.7932C20.9415 22.5265 21.3684 22.0999 21.6351 21.5762C21.9382 20.9815 21.9382 20.2034 21.9382 18.6478V16.1388M23.3297 9.18119V2.22363M23.3297 2.22363H16.3722M23.3297 2.22363L13.5891 11.9642"
                stroke="white"
                stroke-width="3.03603"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_179_2758">
                <rect width="25" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Button>
      </a>
      <Grid container direction="column" spacing={1} sx={{ mt: 1 }}>
        {data.url_service && (
          <Grid item>
            <Typography>
              <strong>Service URL:</strong>{" "}
              <Link href={data.url_service}>{data.url_service}</Link>
            </Typography>
          </Grid>
        )}
        {data.smmpanel_loginuser && (
          <Grid item>
            <Typography>
              <strong>User:</strong> {data.smmpanel_loginuser}
            </Typography>
          </Grid>
        )}
        {data.smmpanel_login_password && (
          <Grid item>
            <Typography>
              <strong>Password:</strong> {data.smmpanel_login_password}
            </Typography>
          </Grid>
        )}
        {data.smmpanel_api_key && (
          <Grid item>
            <Typography>
              <strong>API Key:</strong> {data.smmpanel_api_key}
            </Typography>
          </Grid>
        )}
        {data.smmpanel_api_url && (
          <Grid item>
            <Typography>
              <strong>API URL:</strong> {data.smmpanel_api_url}
            </Typography>
          </Grid>
        )}
        {data.smmpanel_ticket_numper && (
          <Grid item>
            <Typography>
              <strong>Tickets:</strong> {data.smmpanel_ticket_numper}
            </Typography>
          </Grid>
        )}
        {data.smmpanel_date_of_ticket && (
          <Grid item>
            <Typography>
              <strong>Ticket Date:</strong>{" "}
              {dayjs(data.smmpanel_date_of_ticket).format("YYYY-MM-DD")}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default UrlDetails;
